import { PropsWithChildren } from 'react';

import { Compose } from '../helpers/Compose';
import { SnackbarContextProvider } from './snackbar';
import { TranslationsContextProvider } from './translations';

export const GlobalContextProvider = ({ children }: PropsWithChildren) => (
  <Compose components={[SnackbarContextProvider, TranslationsContextProvider]}>{children}</Compose>
);
